import axios from 'axios';
import { writable } from 'svelte/store';
const googleApiKey = 'AIzaSyC3bgM52SVzQlL_bcxO3DOXGQt0_XqMtU8';
export class GoogleFontsClient {
    client;
    constructor() {
        this.client = axios.create({
            baseURL: 'https://www.googleapis.com/webfonts/v1/webfonts'
        });
    }
    fetch(page = 1, limit = 10) {
        return this.client.get('/', {
            params: {
                key: googleApiKey
            }
        });
    }
}
const googleFontsService = new GoogleFontsClient();
const { update, set, subscribe } = writable({
    loading: false,
    loaded: false,
    fonts: []
});
let tempStore;
const unsubscribe = subscribe(store => {
    tempStore = store;
});
const googleFontsStore = {
    update,
    set,
    subscribe,
    getFonts: () => {
        update(store => {
            googleFontsService.fetch().then(({ data, status }) => {
                if (status == 401)
                    throw 'Unauthorized request';
                if (data.items && data.items.length)
                    update(store => ({ ...store, fonts: data.items, loading: false }));
            });
            return { ...store, loading: true };
        });
    }
};
export default googleFontsStore;
